import { apiFetch } from "../client"

export async function listAgents(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/agents${query}`)
}

export async function getAgentPipeline(agentId: string, params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/agents/${agentId}/pipeline${query}`)
}

export async function getAgentClients(agentId: string, params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/agents/${agentId}/clients${query}`)
}

export async function getAgentClient(agentId: string, clientId: string) {
  return apiFetch<any>(`/agents/${agentId}/clients/${clientId}`)
}

export async function getAgentInteractions(agentId: string, params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/agents/${agentId}/interactions${query}`)
}

export async function getAgentTasks(agentId: string) {
  return apiFetch<any>(`/agents/${agentId}/tasks`)
}

export async function getAgentPerformance(agentId: string) {
  return apiFetch<any>(`/agents/${agentId}/performance`)
}

export async function getAgentPerformanceTrend(agentId: string, params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/agents/${agentId}/performance/trend${query}`)
}

export async function getAgentTargets(agentId: string) {
  return apiFetch<any>(`/agents/${agentId}/targets`)
}

export async function createAgentInteraction(agentId: string, payload: Record<string, unknown>) {
  return apiFetch<any>(`/agents/${agentId}/interactions`, {
    method: "POST",
    rawBody: payload,
  })
}

export async function updateAgentPipelineStatus(agentId: string, payload: Record<string, unknown>) {
  return apiFetch<any>(`/agents/${agentId}/pipeline-status`, {
    method: "POST",
    rawBody: payload,
  })
}
